<template>
  <div class="payment-wrapper">
    <div class="header">
      <payment-logo :product-type="productType" />
    </div>
    <div class="container">
      <img
        style="width: 80px;"

        src="@assets/images/pay-success.png"
      >
      <div style="font-size: 20px;font-weight: bold;margin-top: 16px;">
        支付成功
      </div>
      <div
        style="color: #666; text-align: center; "
        v-if="productType === 'leads_personal'"
      >
        请点击前往
        <a
          :href="LOGIN_URL"
          target="_blank"
        >体验版</a>
        ，或复制地址访问体验版 {{ LOGIN_URL }}
      </div>
      <div
        style="color: #666;"
        v-else
      >
        可前往 OKKI IO 插件/管理后台查看购买记录
      </div>
    </div>
  </div>
</template>

  <script>
  import PaymentLogo from '../component/PaymentLogo.vue';

  const LOGIN_URL = 'https://marketing.xiaoman.cn';

  export default {
      name: "PaymentSuccess",
      components: {
        PaymentLogo,
      },
      data() {
          return {
            LOGIN_URL,
          };
      },
      computed: {
        productType() {
          return this.$route.query.productType;
        },
      }
  };
  </script>

  <style lang="scss" >
  .payment-wrapper{
      width: 100vw;
      height: 100vh;
      background-color: #f5f5f5;
  }
  .header{
      padding: 20px 24px;
      height: 60px;
      width: 100%;
      background: #fff;
      border-color: #F0F0F0;
      margin-bottom: 1px;
      box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.05);
      /* 屏幕高度或宽度小于600px时不展示 */
      @media screen and (max-width: 600px) {
          display: none;
      }
  }
  .container {
      background: #fff;
      height: calc(100% - 59px);
      margin-top: 1px;
      box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.05);
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-top: 160px;
      @media screen and (min-width: 1024px) {
          width: 800px;
          margin: auto;
      }

      @media screen and (max-width: 600px) {
          height: 100%;
      }
  }
  </style>
